export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <a href="#hero" className="font-heading text-2xl text-primary-400 mb-4 block">
                91吃瓜
              </a>
              <p className="text-sm text-foreground-400 leading-relaxed">
                91吃瓜视频专区，提供91吃瓜在线观看、高清视频、最新视频资源与视频大全，流畅在线播放吃瓜内容。汇聚全网热门话题，每日更新精彩视频。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-100 mb-4">快速导航</h4>
              <nav className="flex flex-col gap-2">
                <a href="#hero" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</a>
                <a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">焦点专题</a>
                <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热门话题</a>
                <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">最新动态</a>
                <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热度榜单</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-100 mb-4">帮助中心</h4>
              <nav className="flex flex-col gap-2">
                <a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">常见问题</a>
                <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">投稿爆料</a>
                <a href="#about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                感谢各合作平台与内容创作者的支持。合作伙伴信息即将公布，敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 91吃瓜. 本站所有视频内容均来自用户分享与公开网络资源。
            </p>
            <p className="text-xs text-foreground-600">
              91吃瓜视频在线观看 — 高清流畅 安全无广告
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}